import Link from "next/link";
import { cx } from "@nju/css";
import { Icon, IconStyleProps } from "@nju/icons";
import { A, Button } from "../Pressable";
import { Text, TextStyleProps } from "../Text";

interface IBackBaseProps {
  text?: string;
  iconColor?: IconStyleProps["tone"];
  textWeight?: TextStyleProps["weight"];
  textTone?: TextStyleProps["tone"];
  noPadding?: boolean;
}

type IBackTypeProps =
  | {
      type: "BUTTON";
      url?: undefined;
      onClick: () => void;
    }
  | {
      type: "LINK";
      url: string;
      onClick?: undefined;
    };

type IBackProps = IBackTypeProps & IBackBaseProps;

export function Back({
  url,
  type,
  text = "Wróć",
  onClick,
  iconColor = "neutral",
  textWeight = "regular",
  textTone = "neutral",
  noPadding = false,
}: IBackProps) {
  return (
    <div className={cx("flex", { "py-0": noPadding, "py-6": !noPadding })}>
      {type === "LINK" && (
        <Link href={url} passHref={true}>
          <A size="inline" variant="simple">
            <span className="inline-flex gap-5">
              <Icon height={24} name="arrow-left" tone={iconColor} width={24} />
              <Text size="m" tone={textTone} weight={textWeight}>
                {text}
              </Text>
            </span>
          </A>
        </Link>
      )}
      {type === "BUTTON" && (
        <Button
          display="inline"
          onPress={onClick}
          size="inline"
          variant="neutral"
        >
          <span className="inline-flex gap-5 cursor-pointer">
            <Icon height={24} name="arrow-left" tone={iconColor} width={24} />
            <Text size="m" tone={textTone} weight={textWeight}>
              {text}
            </Text>
          </span>
        </Button>
      )}
    </div>
  );
}
